import { useState, useEffect, useRef } from 'react'

export const useInputFieldSync = (externalValue: any) => {
  const [internalValue, setInternalValue] = useState(externalValue ?? '')
  const [externalUpdateTimestamp, setExternalUpdateTimestamp] = useState(() =>
    Date.now(),
  )
  const lastExternalValue = useRef(externalValue)
  const isUserTyping = useRef(false)

  useEffect(() => {
    const hasValueChanged = externalValue !== lastExternalValue.current
    const isExternalUpdate = !isUserTyping.current

    if (hasValueChanged && isExternalUpdate) {
      setInternalValue(externalValue ?? '')
      lastExternalValue.current = externalValue
      setExternalUpdateTimestamp(Date.now())
    }
  }, [externalValue])

  const handleChange = (
    newValue: any,
    setFieldValue: (name: string, value: any) => void,
    fieldName: string,
  ) => {
    isUserTyping.current = true
    setInternalValue(newValue)
    setFieldValue(fieldName, newValue)

    lastExternalValue.current = newValue

    setTimeout(() => {
      isUserTyping.current = false
    }, 100)
  }

  return {
    internalValue,
    externalUpdateTimestamp,
    handleChange,
  }
}
